import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import MainButton from '../../../shared/layout/buttons/MainButton';
import { fetchAdminInvoices } from '../../../services/Http/AdminApi';
import { useCurrency } from '../../../context/CurrencyProvider';

const AdminInvoices = () => {
    const { formatEurAmount } = useCurrency();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const load = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await fetchAdminInvoices({ period: '30d', per_page: 25 });
            setRows(resp?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load invoices');
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { load(); }, [load]);

    const columns = useMemo(() => ([
        { key: 'invoice_number', label: 'Invoice #' },
        { key: 'organization_name', label: 'Organization' },
        { key: 'bill_status', label: 'Bill Status' },
        { key: 'issued_at', label: 'Issued At', render: (r) => r.issued_at ? new Date(r.issued_at).toLocaleString() : '—' },
        { key: 'total_amount', label: 'Total', render: (r) => formatEurAmount(r.total_amount) },
        { key: 'pdf_url', label: 'PDF', render: (r) => r.pdf_url ? 'Available' : '—' },
    ]), [formatEurAmount]);

    return (
        <PageContainer>
            <PageHeader><PageTitle>Invoices</PageTitle></PageHeader>
            <PageContent>
                <AdminFilterBar><div>Issued invoices with billing linkage</div><MainButton size="small" onClick={load}>Refresh</MainButton></AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No invoices found" />
            </PageContent>
        </PageContainer>
    );
};
export default AdminInvoices;
